export enum PaymentEventTypes {
  INITIATED = "hyper.payment.initiated",
  SUCCESSFUL = "hyper.payment.successful",
  FAILED = "hyper.payment.failed",
  ERROR = "hyper.payment.error",
}

export enum ConnectAccountsEvents {
  SUCCESSFUL = "hyper.connect_account.successful",
  FAILED = "hyper.connect_account.failed",
  ERROR = "hyper.connect_account.error",
}
